/** Shared dialog title bar for label-separation modals (title, optional subtitle, close). */
import React from 'react';
import { DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './labelSeparation.styles';

type LabelSeparationDialogHeaderProps = {
  title: string;
  subtitle?: string;
  onClose: () => void;
  closeDisabled?: boolean;
};

const LabelSeparationDialogHeader = ({
  title,
  subtitle = '',
  onClose,
  closeDisabled = false
}: LabelSeparationDialogHeaderProps) => (
  <DialogTitle sx={styles.dialogTitle}>
    <Typography component='h2' variant='h5' sx={styles.dialogTitleText}>
      {title}
      {subtitle ? ` — ${subtitle}` : ''}
    </Typography>
    <IconButton
      aria-label='close'
      disabled={closeDisabled}
      onClick={onClose}
      sx={styles.dialogCloseButton}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>
);

LabelSeparationDialogHeader.defaultProps = {
  subtitle: '',
  closeDisabled: false
};

export default LabelSeparationDialogHeader;
